(ns app.front.view.group.admin.core
  (:require [app.front.entities :as entities]
            [clojure.set :as set]
            [core.front.i18n :as i18n]
            [core.util.util :as util]
            [re-frame.core-instrumented :as rf]))

(rf/reg-event-fx ::fetch-config
  (fn [_ [_ group-id]]
    (let [cmd :group/configuration]
      {:fx [[:dispatch [::set-fetching-config group-id cmd]]
            [:comm/command {:command    cmd
                            :method     :get
                            :data       {:group-id group-id}
                            :on-success [::config-fetched group-id cmd]}]]})))


(rf/reg-event-fx ::config-fetched
  (fn [_ [_ group-id command status resp]]
    {:fx (concat [[:dispatch [::entities/merge-entity-db status resp]]
                  [:dispatch [::clear-fetching-config group-id command]]]
                 (->> (get-in resp [group-id :group/languages])
                      (mapv (fn [lang] [:dispatch [::i18n/fetch-locale-dict-if-not-loaded lang]]))))}))


(rf/reg-event-db ::set-fetching-config
  (fn [db [_ group-id command]]
    (update-in db [::fetching-config group-id] #(-> % set (conj command)))))


(rf/reg-event-db ::clear-fetching-config
  (fn [db [_ group-id command]]
    (update-in db [::fetching-config group-id] #(-> % set (disj command)))))


(rf/reg-sub ::fetching-config?
  (fn [db [_ group-id command]]
    (-> (get-in db [::fetching-config group-id]) (contains? command))))


(rf/reg-sub ::pending-config-fetches
  (fn [db [_ group-id commands]]
    (set/intersection (get-in db [::fetching-config group-id]) (set commands))))


(rf/reg-event-fx
  ::save-config.success
  (fn [_ [_ on-success status resp]]
    {:dispatch-n [[::entities/apply-changes status resp]
                  [:notifications/add :toast :success :success ""]
                  (when on-success
                    (on-success resp))]}))


(rf/reg-event-fx
  ::save-payment-config
  (fn [_ [_ group-id entity-id attribute-value-map]]
    {:comm/command {:command    :group/set-payment-config
                    :method     :post
                    :data       {:group-id         group-id
                                 :entity-id        entity-id
                                 :attribute-values attribute-value-map}
                    :on-success [::save-config.success nil]}}))


(rf/reg-event-fx ::save-group-config
  ;; on-success is a function that takes the command's response as argument and returns a dispatch event vec
  (fn [_ [_ group-id config-id attribute-values on-success]]
    {:fx [[:dispatch [:comm/command-monitored {:command    :group/set-group-config
                                               :method     :post
                                               :data       (util/mmap group-id
                                                                      config-id
                                                                      attribute-values)
                                               :on-success [::save-config.success on-success]}]]]}))


(defn do-save-group-config [group-config-entity attribute-value-map]
  (rf/dispatch [::save-group-config
                (-> group-config-entity :group.config/group :db/id)
                (:db/id group-config-entity)
                attribute-value-map
                nil]))


(rf/reg-sub ::saving-config?
  :<- [:comm/command-processing? :group/set-group-config]
  :-> identity)
